import { defineComponent as l } from "vue";
import { D as d } from "./DIcon-DfNlyxiw.js";
import { b as p, a, E as c } from "./const-DEOau_fL.js";
import { n as u } from "./_plugin-vue2_normalizer-WQT2Fc8L.js";
import './assets/DButton-CCDja8cG.css';var _ = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.BLACK = "black", e.GREY = "grey", e.WHITE = "white", e.DANGER = "danger", e))(_ || {}), n = /* @__PURE__ */ ((e) => (e.LARGE = "large", e.SMALL = "small", e))(n || {});
const i = /* @__PURE__ */ l({
  __name: "DButton",
  props: {
    color: { type: String, default: _.PRIMARY },
    size: { type: String, default: n.LARGE },
    disabled: Boolean,
    dark: Boolean,
    short: Boolean,
    peakyCorners: Boolean,
    /** если указан, ренередится как ссылка, иначе - кнопка */
    to: { type: String, default: void 0 },
    /** аналогично `<a target="" />` */
    target: { type: String, default: void 0 },
    loading: Boolean,
    /** блоковый/строчный элемент */
    block: Boolean
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    return { __sfc: !0, props: e, emit: t, EColor: _, ESize: n, DIcon: d, EIcon: p, EIconColor: a, EIconSize: c };
  }
}), b = "_spin_1j4ee_1", y = {
  "d-button": "_d-button_1j4ee_7",
  "d-button_block": "_d-button_block_1j4ee_26",
  "d-button_rounded": "_d-button_rounded_1j4ee_29",
  "d-button__prepend": "_d-button__prepend_1j4ee_32",
  "d-button__append": "_d-button__append_1j4ee_37",
  "d-button_size-large": "_d-button_size-large_1j4ee_42",
  "d-button_size-large_short": "_d-button_size-large_short_1j4ee_53",
  "d-button_size-small": "_d-button_size-small_1j4ee_63",
  "d-button_size-small_short": "_d-button_size-small_short_1j4ee_74",
  "d-button_color-primary": "_d-button_color-primary_1j4ee_84",
  "d-button_color-primary_dark": "_d-button_color-primary_dark_1j4ee_94",
  "d-button_color-black": "_d-button_color-black_1j4ee_104",
  "d-button_color-black_dark": "_d-button_color-black_dark_1j4ee_114",
  "d-button_color-grey": "_d-button_color-grey_1j4ee_124",
  "d-button_color-grey_dark": "_d-button_color-grey_dark_1j4ee_134",
  "d-button_color-white": "_d-button_color-white_1j4ee_144",
  "d-button_color-white_dark": "_d-button_color-white_dark_1j4ee_154",
  "d-button_color-danger": "_d-button_color-danger_1j4ee_164",
  "d-button_color-danger_dark": "_d-button_color-danger_dark_1j4ee_174",
  "d-button__icon_spin": "_d-button__icon_spin_1j4ee_197",
  spin: b
};
var k = function() {
  var t = this, r = t._self._c, o = t._self._setupProxy;
  return r(o.props.to ? "a" : "button", t._b({ tag: "component", staticClass: "d-button", class: {
    [t.$style["d-button"]]: !0,
    [t.$style["d-button_rounded"]]: !o.props.peakyCorners,
    [t.$style["d-button_color-primary"]]: o.props.color === o.EColor.PRIMARY,
    [t.$style["d-button_color-black"]]: o.props.color === o.EColor.BLACK,
    [t.$style["d-button_color-grey"]]: o.props.color === o.EColor.GREY,
    [t.$style["d-button_color-white"]]: o.props.color === o.EColor.WHITE,
    [t.$style["d-button_color-danger"]]: o.props.color === o.EColor.DANGER,
    [t.$style["d-button_color-primary_dark"]]: o.props.dark && o.props.color === o.EColor.PRIMARY,
    [t.$style["d-button_color-black_dark"]]: o.props.dark && o.props.color === o.EColor.BLACK,
    [t.$style["d-button_color-grey_dark"]]: o.props.dark && o.props.color === o.EColor.GREY,
    [t.$style["d-button_color-white_dark"]]: o.props.dark && o.props.color === o.EColor.WHITE,
    [t.$style["d-button_color-danger_dark"]]: o.props.dark && o.props.color === o.EColor.DANGER,
    [t.$style["d-button_size-large"]]: o.props.size === o.ESize.LARGE,
    [t.$style["d-button_size-small"]]: o.props.size === o.ESize.SMALL,
    [t.$style["d-button_size-large_short"]]: o.props.short && o.props.size === o.ESize.LARGE,
    [t.$style["d-button_size-small_short"]]: o.props.short && o.props.size === o.ESize.SMALL,
    [t.$style["d-button_block"]]: o.props.block
  }, attrs: { disabled: o.props.disabled || o.props.loading }, on: { click: function(f) {
    return o.emit("click");
  } } }, "component", {
    type: o.props.to ? void 0 : "button",
    href: o.props.to ? o.props.to : void 0,
    target: o.props.to ? o.props.target : void 0
  }, !1), [t.$slots.prepend ? r("div", { class: t.$style["d-button__prepend"] }, [t._t("prepend")], 2) : t._e(), t._t("default"), t.$slots.append || o.props.loading ? r("div", { class: t.$style["d-button__append"] }, [t._t("append"), r(o.DIcon, { class: t.$style["d-button__icon_spin"], attrs: { name: o.EIcon.LOADERS_DEFAULT, color: o.EIconColor.PRIMARY, size: o.EIconSize.S_24 } })], 2) : t._e()], 2);
}, m = [];
const s = {
  $style: y
};
function E(e) {
  for (var t in s)
    this[t] = s[t];
}
var g = /* @__PURE__ */ u(
  i,
  k,
  m,
  !1,
  E
);
const A = g.exports;
export {
  A as D,
  n as E,
  _ as a
};
